<template>
  <n-input :value="inputValue" @update:value="onTextInput" @keyup="onKeyup"></n-input>
</template>
<script lang="ts" setup>
import { computed, watch } from "vue"
import formater from "@/util/NumberFormater"

const props = withDefaults(
  defineProps<{
    value: number | undefined
    format?: "integer" | "decimal"
    editable?: boolean
  }>(),
  {
    value: undefined,
    format: "integer",
    editable: true,
  }
)

const emits = defineEmits<{
  "update:value": [value: string]
  keyup: [e: KeyboardEvent]
}>()

const onKeyup = (e: KeyboardEvent) => {
  emits("keyup", e)
}

const inputValue = computed(() => {
  if (props.value == undefined) {
    return ""
  }
  return props.value + ""
})

const onTextInput = (text: string) => {
  if (!props.editable) {
    return
  }
  if (props.format == "integer") {
    emits("update:value", formater.formatIntegerInput(text))
  } else if (props.format == "decimal") {
    emits("update:value", formater.formatDecimalInput(text))
  }
}

watch(
  () => props.format,
  (newF, oldF) => {
    if (props.value == undefined) {
      return
    }
    if (oldF == "decimal" && newF == "integer") {
      emits("update:value", formater.formatIntegerInput(props.value + ""))
    }
  }
)
</script>
<style scoped></style>
